import { ACTIVATE } from "../configs/routes";
import { AccountLockedError, getApiErrorDetail } from "../utils/authErrors";
import api from "./api";

export const activateAccount = async (body) => {
  try {
    const response = await api.post(ACTIVATE, body);
    return response.data;
  } catch (err) {
    const status = err?.response?.status;
    const detail = getApiErrorDetail(err);
    if (status === 403) throw new AccountLockedError(detail);
    throw err;
  }
};
